module.exports = __webpack_public_path__ + "img/170.dining_room.cc36c23a.svg";